module.exports = __webpack_public_path__ + "static/media/video.90dc614b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/video.jpg
// module id = 237
// module chunks = 0